/** Color mode is independent of the seasonal artwork package (see season.ts). */
export const THEMES = ['light', 'dark'] as const;

export type Theme = (typeof THEMES)[number];

/** Used when there is neither a stored choice nor an OS preference to read. */
export const DEFAULT_THEME: Theme = 'light';

export const THEME_STORAGE_KEY = 'santa_theme';

export function isTheme(value: unknown): value is Theme {
  return typeof value === 'string' && (THEMES as readonly string[]).includes(value);
}
